export default function Footer() {
  return (
    <footer
      id="footer"
      style={{
        padding: "40px 20px",
        background: "#2a2a2a",
        textAlign: "center",
      }}
    >
      <p>CarFinders South Africa - Driven To Find Your Perfect Match.</p>
      <p>
        Professional vehicle sourcing and dealership assistance across South
        Africa.
      </p>
      <p>
        Phone: 068 159 3340 | Email:{" "}
        <a
          href="mailto:carfinderssa@gmail.com"
          style={{ color: "var(--gold)", textDecoration: "none" }}
        >
          carfinderssa@gmail.com
        </a>{" "}
        | Website:{" "}
        <a
          href="https://www.carfinderssa.co.za"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "var(--gold)", textDecoration: "none" }}
        >
          www.carfinderssa.co.za
        </a>
      </p>
    </footer>
  );
}
